import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ParticleCanvas } from "../components/ParticleCanvas";
import { ParallaxBg } from "../components/ParallaxBg";
import { VideoEmbed } from "../components/VideoEmbed";
import { Countdown } from "../components/Countdown";
import { BONUSES, WEBINAR } from "../lib/copy";

export default function Hero() {
  const heroRef = useRef(null);

  useEffect(() => {
    const lines = heroRef.current.querySelectorAll(".h1-inner");
    gsap.to(lines, { y: 0, duration: 1.1, ease: "power3.out", stagger: 0.12, delay: 0.3 });
    gsap.fromTo(
      heroRef.current.querySelectorAll(".hero-fade"),
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 0.9, ease: "power2.out", stagger: 0.1, delay: 0.85 }
    );
  }, []);


  return (
    <section ref={heroRef} className="relative min-h-screen flex items-center overflow-hidden" data-testid="hero-section">
      <ParallaxBg image="/bg/home1.jpg" />
      <div className="hero-fade absolute top-6 left-6 mono hidden md:block" style={{ fontSize: 14, letterSpacing: "0.2em", color: "rgba(255,255,255,0.6)" }}>
        <i className="fa-regular fa-calendar mr-2" style={{ color: "#3D7BFF" }}></i>
        {WEBINAR.date} AT {WEBINAR.time} {WEBINAR.timezone}
      </div>

      <div className="relative w-full max-w-[1400px] mx-auto px-6 lg:px-12 pt-28 pb-16 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* LEFT */}
        <div>
          <p className="eyebrow mb-6 hero-fade" style={{ fontSize: 13, color: "#FFFFFF", fontWeight: 700 }} data-testid="hero-eyebrow">FREE 60-MINUTE LIVE SESSION FOR VA BUYERS — NC · SC · GA · FL · TX · TN · CO · IN</p>
          <h1 className="hero-h1 mb-7" data-testid="hero-h1">
            <span className="h1-line"><span className="h1-inner line-accent">THE VA HOME-READY BLUEPRINT —</span></span>
            <span className="h1-line"><span className="h1-inner">KNOW WHAT YOU QUALIFY FOR</span></span>
            <span className="h1-line"><span className="h1-inner line-dim">FROM SOMEONE WHO SEES THE WHOLE DEAL</span></span>
          </h1>
          <div className="hero-fade mb-7" style={{ maxWidth: 560 }}>
            <div className="hero-video-frame" data-testid="hero-video">
              <VideoEmbed
                src="https://customer-assets-m6fa6gv7.emergentagent.net/job_va-loan-guide/artifacts/d24qw2jo_TOF%201.mp4"
                poster="/poster-tof.jpg"
                testid="hero-video-player"
              />
            </div>
          </div>
          <p className="hero-fade mb-6" style={{ fontSize: 15, color: "#F0ECE4", lineHeight: 1.7, maxWidth: 520 }}>
            The free webinar that shows <span style={{ color: "#3D7BFF" }}>VA-eligible buyers</span> exactly what they qualify for and how to close — from a lender who's also a licensed realtor.
          </p>
          <blockquote className="hero-blockquote hero-fade mb-8" style={{ maxWidth: 480 }}>
            What if the person underwriting your loan could also tell you, in the same conversation, whether the house actually makes sense?
          </blockquote>
          <div className="hero-fade mb-8">
            <p className="mono mb-3" style={{ fontSize: 13, letterSpacing: "0.24em", color: "rgba(255,255,255,0.6)" }}>
              LIVE ON {WEBINAR.date} · {WEBINAR.time} {WEBINAR.timezone} — SEATS CLOSE IN:
            </p>
            <Countdown compact />
          </div>
          <div className="hero-fade flex items-center gap-4 mt-12" data-testid="hero-host-module">
            <img src="/matthew.jpg" alt="Matthew Lake-Nestor" className="avatar-photo" />
            <div>
              <p className="font-bold text-sm">{WEBINAR.host}</p>
              <p className="mono" style={{ fontSize: 10, letterSpacing: "0.14em", color: "var(--muted)" }}>
                {WEBINAR.company.toUpperCase()} · NMLS# {WEBINAR.nmls}
              </p>
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="relative">
          <div className="absolute -top-28 -bottom-28 -left-56 -right-16 hidden md:block">
            <ParticleCanvas scrollTriggerRef={heroRef} />
          </div>
          <div className="glass-card relative p-7 md:p-8" data-testid="hero-registration-card">
            <p className="eyebrow mb-2">DON'T MISS OUT</p>
            <h3 className="font-extrabold text-lg mb-5">When You Register, You'll Receive:</h3>
            <ul className="space-y-3 mb-5">
              {BONUSES.map((b, i) => (
                <li key={i} className="flex gap-3 items-start text-sm" style={{ color: "rgba(240,236,228,0.8)" }} data-testid={`bonus-item-${i + 1}`}>
                  <span style={{ color: "#3D7BFF", fontWeight: 700 }}>✓</span>
                  <span>{b}</span>
                </li>
              ))}
            </ul>
            <p className="font-extrabold mb-5" style={{ color: "#3D7BFF", fontSize: 22 }}>FREE!</p>
          </div>
        </div>
      </div>
    </section>
  );
}
